import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Toast from './Toast';
import { CheckCircle, ErrorCircle } from '../components/icons/svgIcons';

const ChangePassword = (props) => {

    const [data, setData] = useState({});
    const [formIsValid, setFormIsValid] = useState(false);
    const [toastRef, setToastRef] = useState(React.createRef()); 

    const handleChange = (event) => {
        setData({ ...data, [event.target.name]: event.target.value })
    }

    useEffect(() => {
    }, []);

    useEffect(() => {
        if (
            data.newPassword && data.repeatPassword && 
            data.newPassword.trim() === data.repeatPassword.trim() && 
            data.newPassword.trim().length>=8 
        ) {
            setFormIsValid(true);
        } else {
            setFormIsValid(false);
        }
    }, [data]);

    const ChangePassword=()=>{
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));       
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/changePassword`,
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            data: {
                newPassword: data.newPassword,
            }
        };

        axios(options).then(response => {
            if (response.status === 200) {
                const resetData = { newPassword: '', repeatPassword: '' };
                setData(resetData);
                toastRef.current.addToast('La contraseña de acceso fue modificada exitósamente,<br/>Es necesario cerrar su sesión de usuario y volver a ingresar.', 8000);
            }
        });

    }

    return (
        <div className="ChangePassword">
            <Toast ref={toastRef}></Toast>
            <h3>Cambio de contraseña</h3>
            <p>
                Ingrese la nueva contraseña y reingrésela para evitar equivocaciones.<br/>
                Se requiere al menos 8 caracteres alfanuméricos.
            </p><br />
            <div className="flexRow gap10">
                <div className="flexCol inputWrapper x2">
                    {data.newPassword && data.newPassword.trim().length >= 8 ? (<CheckCircle className="floatRight" width="25" height="25" color="#30BD2F" />) : data.newPassword?(<ErrorCircle className="floatRight" width="25" height="25" color="#EA9393" />):null}
                    <label>Nueva contraseña</label>
                    <input type="password" name="newPassword" value={data.newPassword} placeholder="Ingrese nueva contraseña" maxLength="15" onChange={handleChange} />
                </div>
                <div className="flexCol inputWrapper x2">
                    {data.repeatPassword && data.newPassword === data.repeatPassword ? (<CheckCircle className="floatRight" width="25" height="25" color="#30BD2F" />) : data.repeatPassword ? (<ErrorCircle className="floatRight" width="25" height="25" color="#EA9393" />) : null}
                    <label>Repita contraseña</label>
                    <input type="password" name="repeatPassword" value={data.repeatPassword} placeholder="Repita nueva contraseña" maxLength="15" onChange={handleChange} />
                </div>
                <button class="default mainAction autoHeight" onClick={ChangePassword} disabled={!formIsValid}>Cambiar contraseña</button>
            </div>
        </div>
    );

}

export default ChangePassword;
